import { render, staticRenderFns } from "./CompuMinuteBoard.vue?vue&type=template&id=0df4dbd5&scoped=true"
import script from "./CompuMinuteBoard.vue?vue&type=script&lang=js"
export * from "./CompuMinuteBoard.vue?vue&type=script&lang=js"
import style0 from "./CompuMinuteBoard.vue?vue&type=style&index=0&id=0df4dbd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df4dbd5",
  null
  
)

export default component.exports